// GreenIn Impact - greenin.org
import { lazy, Suspense } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import SkipLink from '@/components/ui/SkipLink';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import ScrollToTop from '@/components/ui/ScrollToTop';
import CookieBanner from '@/components/ui/CookieBanner';
import HeroSection from '@/components/sections/HeroSection';
import ChatWidget from '@/components/chat/ChatWidget';

// Lazy-load below-fold sections to reduce initial JS bundle and improve LCP
const AboutSection = lazy(() => import('@/components/sections/AboutSection'));
const ReinvestmentSection = lazy(() => import('@/components/sections/ReinvestmentSection'));
const EcosystemSection = lazy(() => import('@/components/sections/EcosystemSection'));
const ProgramsSection = lazy(() => import('@/components/sections/ProgramsSection'));
const AIForGoodSection = lazy(() => import('@/components/sections/AIForGoodSection'));
const CircularImpactSection = lazy(() => import('@/components/sections/CircularImpactSection'));
const TransparencySection = lazy(() => import('@/components/sections/TransparencySection'));
const GetInvolvedSection = lazy(() => import('@/components/sections/GetInvolvedSection'));
const ContactSection = lazy(() => import('@/components/sections/ContactSection'));
const FAQSection = lazy(() => import('@/components/sections/FAQSection'));

const Index = () => {
  const { language } = useLanguage();
  
  return (
    <div className="min-h-screen bg-background">
      <SkipLink />
      <Header />
      <main id="main-content">
        <HeroSection />
        <Suspense fallback={null}>
          <AboutSection />
          <ReinvestmentSection />
          <EcosystemSection />
          <ProgramsSection />
          <AIForGoodSection />
          <CircularImpactSection />
          <TransparencySection />
          <GetInvolvedSection />
          <ContactSection />
          <FAQSection />
        </Suspense>
      </main>
      <Footer />
      <ScrollToTop />
      <CookieBanner />
      <ChatWidget />
    </div>
  );
};

export default Index;
